import React from 'react';

const GalleryLayout = ({ content }) => {
    const galleries = content.main?.gallery || [];

    return (
        <div className="container mx-auto px-4 py-12">
            {/* Page Title */}
            <h1 className="text-3xl font-bold font-montserrat text-gray-900 mb-8">
                {content.title}
            </h1>

            {/* GalleryLayout Grid */}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {galleries.map((gallery, index) => (
                    <div key={index} className="bg-white rounded-lg shadow-sm overflow-hidden">
                        <div className="aspect-square">
                            <img 
                                src={gallery.image} 
                                alt={gallery.title || 'galleri billede'} 
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="p-4">
                            {gallery.title && (
                                <h3 className="text-lg font-semibold font-montserrat text-gray-900 mb-2">
                                    {gallery.title}
                                </h3>
                            )}
                            {gallery.description && (
                                <p className="text-gray-600">
                                    {gallery.description}
                                </p>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GalleryLayout;